import randomString from '../../../uid/randomString';

/**
 * Generates a task item's stable `taskId`.
 *
 * Shared by the editor's UniqueID configuration and by anything that builds task item JSON
 * outside an editor, so an id stamped ahead of time is indistinguishable from an editor's own.
 */
export const generateTaskId = (): string => `task-${randomString(14)}`;
